export const defaultValue = {
};

export const VOLTAGE_TYPES = {
  LOW_VOLTAGE: "lowVoltage",
  MEDIUM_VOLTAGE: "mediumVoltage",
};

export const TERMS = {
  SINGLE_TERM: "singleTerm",
  DOUBLE_TERM: "doubleTerm",
};

export const MARKET_TYPES = {
  FREE_MARKET: "freeMarket",
  RETAIL_COMPANY: "retailCompany",
};

export const STROKE_TIMES = {
  SINGLE_STROKE: "singleStroke",
  MULTIPLE_STROKE: "multipleStroke",
};

export const TARIFF_SECTOR_DROPDOWN = [
  {
    label: "industry",
    value: "Industry",
  },
  {
    label: "publicAndPrivateServices",
    value: "Public",
  },
] as const;

export const MIN_PAYMENT_DAY_VALUE = -30;
export const MAX_PAYMENT_DAY_VALUE = 30;
